document.addEventListener('DOMContentLoaded', () => {
    class App {
        constructor() {
            this.ready = false;
            this.body = document.body;
            this.imagesLoaded = false;
            this.menu = null;
            this.cursor = null;
            this.ie = false;

            this.DOM = {
                scrollable: document.querySelector('.scrollable'),
                page: document.getElementById('page'),
                menu: document.getElementById('mainMenu'),
                cursor: document.getElementById('cursor'),
                header: document.querySelector('header.main'),
                footer: document.querySelector('footer.site-footer')
            };

            this.winsize = {};
            this.content = {
                first: document.querySelector('.content--first'),
                second: document.querySelector('.content--second')
            };
            this.revealer = null;
            this.pageToggleTimeline = null;

            this.windowHeight = window.innerHeight;
            this.helpers = new Helpers();
            this.front = new Front();

            window.helpers = this.helpers;
        }

        init() {
            luxy.init({ wrapper: '#page', targets: 'luxy-el' });

            imagesLoaded(document.querySelector('img'), () => {
                this.imagesLoaded = true;
                this.body.classList.remove('loading');
                this.showNextPage();
            });

            SmoothParallax.init({
                basePercentageOn: 'containerVisibility'
            });

            if (!this.menu) {
                this.menu = new Menu(this.DOM.menu);
            }

            // Revealer element
            this.revealer = new Revealer(this.content.first, {
                angle: 110
            });

            this.initAnimations();
            this.addEventHandlers();
            this.front.init();

            window.cookieconsent.initialise({
                palette: {
                    popup: {
                        background: '#ffffff'
                    },
                    button: {
                        background: '#fff',
                        text: '#3e3e3e'
                    }
                },
                cookie: {
                    name: 'cookieconsent_status',
                    expiryDays: 21
                },
                theme: 'edgeless',
                position: 'bottom-left',
                content: {
                    message: dynamic.translations.cookiesText,
                    dismiss: '&#10005;',
                    link: dynamic.translations.knowMore,
                    href: dynamic.privacyLink
                }
            });
        }

        initAnimations() {
            this.windowHeight = window.innerHeight;

            if (document.getElementById('main')) {
                document.getElementById('main').style.minHeight = window.innerHeight - this.DOM.header.clientHeight - this.DOM.footer.clientHeight + 'px';
            }

            this.checkPosition();

            inView('[data-inview]')
                .on('enter', (inViewEl) => {
                    inViewEl.classList.add('inview-visible');
                })
                .on('exit', (inViewEl) => {
                    if (!inViewEl.classList.contains('once')) {
                        inViewEl.classList.remove('inview-visible');
                    }
                    else {
                        inViewEl.removeAttribute('data-inview');
                    }
                });

            const lettering = document.querySelector('h1.lettering');
            if (lettering) {
                charming(lettering);
                setTimeout(() => {
                    Array.from(lettering.querySelectorAll('span')).forEach((letter, index) => {
                        TweenMax.fromTo(
                            letter,
                            0.1,
                            { opacity: 0 },
                            { opacity: 1 }
                        ).delay(index * 0.08);
                    });
                }, 1200);
            }
        }

        addEventHandlers() {
            const self = this;
            this.checkPosition = this.checkPosition.bind(this);
            this.initAnimations = this.initAnimations.bind(this);

            window.addEventListener('scroll', this.checkPosition);
            window.addEventListener('resize', this.initAnimations);

            document.getElementById('navToggle').addEventListener('click', (ev) => {
                ev.stopPropagation();
                this.menu.toggle();
            });

            if (BrowserDetect.browser === 'Explorer' && BrowserDetect.version <= 11) {
                this.body.classList.add('ie');
                this.ie = true;
            }

            if (!this.helpers.isMobile() && !this.ie) {
                this.cursor = new CursorFx(document.getElementById('cursor'));

                Array.from(document.querySelectorAll('img, video, .white-cursor')).forEach((el) => {
                    el.addEventListener('mouseover', (e) => {
                        this.DOM.cursor.classList.add('white');
                    });

                    el.addEventListener('mouseout', (e) => {
                        this.DOM.cursor.classList.remove('white');
                    });
                });

                Array.from(document.querySelectorAll('.no-dot')).forEach((el) => {
                    el.addEventListener('mouseover', (e) => {
                        this.DOM.cursor.style.opacity = 0;
                    });

                    el.addEventListener('mouseout', (e) => {
                        this.DOM.cursor.style.opacity = 1;
                    });
                });
            }

            Array.from(document.querySelectorAll('[data-video]')).forEach((btn) => {
                if (btn.getAttribute('data-video')) {
                    const id = btn.getAttribute('data-video');
                    const video = document.getElementById('video' + id);

                    if (!video) {
                        return;
                    }

                    const section = document.getElementById('video_section_' + id);
                    if (section) {
                        btn.addEventListener('click', (ev) => {
                            ev.preventDefault();
                            section.classList.add('playing');
                            video.play();
                        });
                        section.querySelector('video').addEventListener('pause', () => {
                            section.classList.remove('playing');
                        });
                    }
                }
            });

            Array.from(document.querySelectorAll('a, .btn, button')).forEach((link) => {
                if (this.cursor) {
                    link.addEventListener('mouseenter', () => this.cursor.enter());
                    link.addEventListener('mouseleave', () => this.cursor.leave());
                }

                link.addEventListener('mousedown', (ev) => {
                    ev.preventDefault();

                    if (ev.button !== 0) {
                        return;
                    }

                    const target = ev.currentTarget;
                    if (!target.getAttribute('href')) return;

                    if (this.cursor) {
                        cursor.click();
                    }

                    if (target.getAttribute('target') && target.getAttribute('target') === '_blank') {
                        window.open(target.getAttribute('href'), '_blank');
                        return;
                    }

                    self.showIntro(() => {
                        window.location.href = target.getAttribute('href');
                    });
                });
            });

            this.calcWinsize();
            window.addEventListener('resize', this.calcWinsize);
            this.mousePos = { x: this.winsize.width / 2, y: this.winsize.height / 2 };
        }

        checkPosition(ev = { clientX: 0, clientY: 0 }) {
            const windowHeight = this.windowHeight;
            const elems = document.querySelectorAll('.animate-letters > p > span');

            for (let i = 0; i < elems.length; i += 1) {
                const positionFromTop = elems[i].getBoundingClientRect().top;
                if (positionFromTop - windowHeight <= 0) {
                    setTimeout(() => {
                        elems[i].classList.add('show');
                    }, 200);
                }
            }
        }

        calcWinsize() {
            this.winsize = { width: window.innerWidth, height: window.innerHeight };
        }

        showNextPage() {
            // Pointer events related class
            this.content.first.classList.add('content--hidden');
            const ease = Expo.easeInOut;
            const duration = 1.2;
            this.pageToggleTimeline = new TimelineMax()
                // 'Unreveal effect' (inner moves to one direction and reverse moves to the opposite one)
                .to(this.revealer.DOM.el, duration, {
                    ease,
                    rotation: '-=40'
                }, 0)
                .to(this.revealer.DOM.inner, duration, {
                    ease,
                    y: '-100%'
                }, 0)
                .to(this.revealer.DOM.reverse, duration, {
                    ease,
                    rotation: '-=-40',
                    y: '100%'
                }, 0);
        }

        showIntro(cb) {
            // Pointer events related class
            this.content.first.classList.remove('content--hidden');
            this.pageToggleTimeline.eventCallback('onReverseComplete', cb);
            this.pageToggleTimeline.reverse();
        }
    }

    const website = new App();
    website.init();
});
